import React, { useState, useEffect } from "react";
import plusIcon from "../../img/add_report_icon.png";
import nestedRowIcon from "../../img/add_nested_row_icon.png";
import deletedIcon from "../../img/delete_report_icon.png";
import "react-calendar/dist/Calendar.css";
import { cloneDeep } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { getConditionOptionArray, getReportById } from "../../actions/reports";
import { Loader } from "../Utils/Loader";
import { useParams, useHistory } from "react-router-dom";
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import { services } from "../../api";
import { ButtonComponent } from "./SubComponents";

export const Reports = (props) => {
  const { data, onBack, isArchive } = props;
  const dispath = useDispatch();
  let params = useParams();
  const [loading, setLoading] = useState(false);
  const [optionData, setOptionData] = useState([]);
  const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] =
    useState(false);
  const history = useHistory();
  const [validationCheck, setValidation] = useState({
    report_name: false,
  });
  const userData = useSelector((state) => state.usersReducers);
  const [payload, setPayload] = useState({
    tab:
      params.type === "customerfacilityfault"
        ? "cff"
        : params.type === "customertrainfault"
        ? "ctf"
        : "cs",
    report_name: "",
    match: "ANY",
    created_by: 1,
    is_archive: isArchive,
    matchParentData: [
      {
        col: "",
        filter: "",
        value: "",
      },
    ],
  });
  const { topSection = {}, filters = {} } = data;

  const optionsData = useSelector((state) => state.reportReducers.optionData);
  let addRowWithChildren;
  let addRowWithoutChildren;

  if (optionData.length > 0) {
    addRowWithChildren = {
      childMatch: "ANY",
      matchChildData: [
        {
          col: optionData[0].labelID,
          colName: optionData[0].labelName,
          filter: optionData[0].condition[0].conditionID,
          filterLabel: optionData[0].condition[0].conditionName,
          value: "",
          selectedChildrenCondition: optionData[0],
        },
      ],
    };

    addRowWithoutChildren = {
      col: optionData[0].labelID,
      colName: optionData[0].labelName,
      filter: optionData[0].condition[0].conditionID,
      filterLabel: optionData[0].condition[0].conditionName,
      value: "",
      selectedCondition: optionData[0],
    };
  }

  const getReportsById = useSelector(
    (state) => state.reportReducers.getReportById
  );

  useEffect(() => {
    if (getReportsById.payload) {
      setLoading(false);
      setPayload(getReportsById.payload);
    }
  }, [getReportsById]);

  useEffect(() => {
    setOptionData(optionsData);
    if (params.id) {
      setLoading(true);
      dispath(getReportById({ report_id: params.id }));
    } else {
      let payloadTemp = {
        tab:
          params.type === "customerfacilityfault"
            ? "cff"
            : params.type === "customertrainfault"
            ? "ctf"
            : "cs",
        report_name: "",
        match: "ANY",
        created_by: 1,
        is_archive: isArchive,
        matchParentData: [
          {
            col: "",
            filter: "",
            value: "",
          },
        ],
      };
      setPayload(payloadTemp);
    }
  }, [optionsData]);

  useEffect(() => {
    let payloadTemp = cloneDeep(payload);
    if (optionData?.length > 0) {
      payloadTemp.matchParentData = payloadTemp?.matchParentData?.map((el) => {
        el.selectedCondition = optionData?.[0] || {};
        return el;
      });
      payloadTemp.matchParentData[0].col =
        payloadTemp?.matchParentData?.[0]?.selectedCondition?.labelID;
      payloadTemp.matchParentData[0].colName =
        payloadTemp?.matchParentData?.[0]?.selectedCondition?.labelName;
      payloadTemp.matchParentData[0].filter =
        payloadTemp?.matchParentData?.[0]?.selectedCondition.condition?.[0]?.conditionID;
      payloadTemp.matchParentData[0].filterLabel =
        payloadTemp?.matchParentData?.[0]?.selectedCondition?.condition?.[0]?.conditionName;
      setPayload(payloadTemp);
    }
  }, [optionData]);

  useEffect(() => {
    dispath(getConditionOptionArray({ tab: payload.tab }));
  }, []);

  const onChangeHandler = (e, index) => {
    let payloadTemp = cloneDeep(payload);
    if (e.target.id === "label") {
      let selectedConditionTemp = optionData.find(
        (el) => el.labelID == e.target.value
      );
      payloadTemp.matchParentData[index].selectedCondition = cloneDeep(
        selectedConditionTemp
      );
      payloadTemp.matchParentData[index].col = selectedConditionTemp.labelID;
      payloadTemp.matchParentData[index].colName =
        selectedConditionTemp.labelName;
      payloadTemp.matchParentData[index].filter =
        selectedConditionTemp.condition[0].conditionID;
      payloadTemp.matchParentData[index].filterLabel =
        selectedConditionTemp.condition[0].conditionName;
      payloadTemp.matchParentData[index].value = "";
    } else if (e.target.id === "condition") {
      let conditionObjTemp = payloadTemp.matchParentData[
        index
      ].selectedCondition.condition.find(
        (el) => el.conditionID == e.target.value
      );
      payloadTemp.matchParentData[index].filter = conditionObjTemp.conditionID;
      payloadTemp.matchParentData[index].filterLabel =
        conditionObjTemp.conditionName;
      payloadTemp.matchParentData[index].value = "";
    } else if (e.target.id === "value") {
      payloadTemp.matchParentData[index][e.target.id] = e.target.value;
    } else if (e.target.id === "match") {
      payloadTemp.match = e.target.value;
    } else if (e.target.id === "report_name") {
      payloadTemp[e.target.id] = e.target.value;
    }
    setPayload(payloadTemp);
  };

  const onChangeChildrenHandler = (e, parentIndex, childIndex) => {
    let payloadTemp = cloneDeep(payload);
    if (e.target.id === "childMatch") {
      payloadTemp.matchParentData[parentIndex][e.target.id] = e.target.value;
    } else if (e.target.id === "value") {
      payloadTemp.matchParentData[parentIndex].matchChildData[childIndex][
        e.target.id
      ] = e.target.value;
    } else if (e.target.id === "childrenLabel") {
      let selectedConditionTemp = optionData.find(
        (el) => el.labelID == e.target.value
      );
      payloadTemp.matchParentData[parentIndex].matchChildData[
        childIndex
      ].selectedChildrenCondition = cloneDeep(selectedConditionTemp);
      payloadTemp.matchParentData[parentIndex].matchChildData[childIndex].col =
        selectedConditionTemp.labelID;
      payloadTemp.matchParentData[parentIndex].matchChildData[
        childIndex
      ].colName = selectedConditionTemp.labelName;
      payloadTemp.matchParentData[parentIndex].matchChildData[
        childIndex
      ].filter = selectedConditionTemp.condition[0].conditionID;
      payloadTemp.matchParentData[parentIndex].matchChildData[
        childIndex
      ].filterLabel = selectedConditionTemp.condition[0].conditionName;
      payloadTemp.matchParentData[parentIndex].matchChildData[childIndex][
        "value"
      ] = "";
    } else if (e.target.id === "childrenCondition") {
      let conditionObjTemp = payloadTemp.matchParentData[
        parentIndex
      ].matchChildData[childIndex].selectedChildrenCondition.condition.find(
        (el) => el.conditionID == e.target.value
      );
      payloadTemp.matchParentData[parentIndex].matchChildData[
        childIndex
      ].filter = conditionObjTemp.conditionID;
      payloadTemp.matchParentData[parentIndex].matchChildData[
        childIndex
      ].filterLabel = conditionObjTemp.conditionName;
      payloadTemp.matchParentData[parentIndex].matchChildData[childIndex][
        "value"
      ] = "";
    }
    setPayload(payloadTemp);
  };

  const dateChangeHandler = (e, index, childIndex) => {
    let payloadTemp = cloneDeep(payload);
    if (typeof childIndex == "number") {
      payloadTemp.matchParentData[index].matchChildData[childIndex].value =
        e.format("YYYY-MM-DD");
    } else {
      payloadTemp.matchParentData[index].value = e.format("YYYY-MM-DD");
    }

    setPayload(payloadTemp);
  };

  const dateChangeInBetweenHandler = (e, index, childIndex, type) => {
    let payloadTemp = cloneDeep(payload);
    if (typeof childIndex == "number") {
      payloadTemp.matchParentData[index].matchChildData[childIndex][type] =
        e.format("YYYY-MM-DD");
    } else {
      payloadTemp.matchParentData[index][type] = e.format("YYYY-MM-DD");
    }

    setPayload(payloadTemp);
  };

  const getInputBoxHandler = (grand, index, childIndex, label) => {
    if (label.col == 55 || label.col == 35 || label.col == 57) {
      if (label.filter === 3) {
        return (
          <>
            <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12">
              <Datetime
                className="calender-input"
                value={
                  typeof childIndex == "number" ? label.value : grand.value
                }
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                onChange={(e) =>
                  dateChangeInBetweenHandler(e, index, childIndex, "value")
                }
              />
            </div>

            {typeof childIndex == "number" ? (
              label.errorMessage ? (
                <div className="msgError help-block">
                  <small className="error feedback-error">
                    Details can not be blank
                  </small>
                </div>
              ) : (
                ""
              )
            ) : grand.errorMessage ? (
              <div className="msgError help-block">
                <small className="error feedback-error">
                  Details can not be blank
                </small>
              </div>
            ) : (
              ""
            )}
            <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12">
              <Datetime
                className="calender-input"
                value={
                  typeof childIndex == "number" ? label.value1 : grand.value1
                }
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                onChange={(e) =>
                  dateChangeInBetweenHandler(e, index, childIndex, "value1")
                }
              />
            </div>
            {typeof childIndex == "number"
              ? label.errorMessage1 && (
                  <div className="msgError help-block">
                    <small className="error feedback-error">
                      Details can not be blank
                    </small>
                  </div>
                )
              : grand.errorMessage1 && (
                  <div className="msgError help-block">
                    <small className="error feedback-error">
                      Details can not be blank
                    </small>
                  </div>
                )}
          </>
        );
      } else {
        return (
          <>
            <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12">
              <Datetime
                className="calender-input"
                value={
                  typeof childIndex == "number" ? label.value : grand.value
                }
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                onChange={(e) => dateChangeHandler(e, index, childIndex)}
              />
            </div>
            {typeof childIndex == "number"
              ? label.errorMessage && (
                  <div className="msgError help-block">
                    <small className="error feedback-error">
                      Details can not be blank
                    </small>
                  </div>
                )
              : grand.errorMessage && (
                  <div className="msgError help-block">
                    <small className="error feedback-error">
                      Details can not be blank
                    </small>
                  </div>
                )}
          </>
        );
      }
    } else if (
      label.col == 52 ||
      label.col == 51 ||
      label.col == 62 ||
      label.col == 42 ||
      label.col == 44
    )
      return <></>;
    else {
      if (typeof childIndex == "number") {
        return (
          <>
            <div className="col-lg-4 col-md-4 col-sm-3 col-xs-12">
              <input
                type="text"
                id="value"
                value={label.value}
                onChange={(e) => onChangeChildrenHandler(e, index, childIndex)}
              />
            </div>
            {label.errorMessage && (
              <span className="msgError help-block">
                <small className="error feedback-error">
                  Details can not be blank
                </small>
              </span>
            )}
          </>
        );
      } else {
        return (
          <>
            <div className="col-lg-4 col-md-4 col-sm-3 col-xs-12">
              <input
                type="text"
                id="value"
                value={grand.value}
                onChange={(e) => onChangeHandler(e, index)}
              />
            </div>
            {grand.errorMessage && (
              <span className="msgError help-block">
                <small className="error feedback-error">
                  {" "}
                  Details can not be blank{" "}
                </small>
              </span>
            )}
          </>
        );
      }
    }
  };

  const addRowHandler = (key, index) => {
    let payloadTemp = cloneDeep(payload);
    let addRowObjTemp;
    console.log(addRowWithoutChildren, 'addRowHandler',addRowWithChildren)
    if (key === "add") {
      addRowObjTemp = cloneDeep(addRowWithoutChildren);
    } else {
      addRowObjTemp = cloneDeep(addRowWithChildren);
    }
    payloadTemp.matchParentData.splice(index + 1, 0, addRowObjTemp);
    setPayload(payloadTemp);
  };

  const addChildrenHandler = (index) => {
    let payloadTemp = cloneDeep(payload);
    let addRowObj = {
      col: optionData[0].labelID,
      filter: optionData[0].condition[0].conditionID,
      value: "",
      colName: optionData[0].labelName,
      filterLabel: optionData[0].condition[0].conditionName,
      selectedChildrenCondition: optionData[0],
    };
    payloadTemp.matchParentData[index].matchChildData.push(addRowObj);
    setPayload(payloadTemp);
  };

  const deleteRowHandler = (key, id, childrenID) => {
    let payloadTemp = cloneDeep(payload);
    if (key === "parent") {
      payloadTemp.matchParentData = payloadTemp.matchParentData.filter(
        (el, index) => index !== id
      );
    } else {
      payloadTemp.matchParentData[id].matchChildData =
        payloadTemp.matchParentData[id].matchChildData.filter(
          (el, index) => index !== childrenID
        );
    }
    setPayload(payloadTemp);
  };
  const onSaveReport = async () => {
    let payloadTemp = cloneDeep(payload);

    payloadTemp.matchParentData = payloadTemp.matchParentData.map((parent) => {
      if (parent.childMatch) {
        parent.matchChildData = parent.matchChildData.map((child) => {
          if (child.filter == 3) {
            if (!child.value) child.errorMessage = true;
            else child.errorMessage = false;

            if (!child.value1) child.errorMessage1 = true;
            else child.errorMessage1 = false;
          } else if (child.filter == 31 || child.filter == 32) {
            child.errorMessage = false;
          } else {
            if (!child.value) {
              child.errorMessage = true;
            } else {
              child.errorMessage = false;
            }
          }
          return child;
        });
      } else {
        if (parent.filter == 3) {
          if (!parent.value) parent.errorMessage = true;
          else parent.errorMessage = false;

          if (!parent.value1) parent.errorMessage1 = true;
          else parent.errorMessage1 = false;
        } else if (parent.filter == 31 || parent.filter == 32) {
          parent.errorMessage = false;
        } else {
          if (!parent.value) {
            parent.errorMessage = true;
          } else {
            parent.errorMessage = false;
          }
        }
      }

      return parent;
    });
    setPayload(payloadTemp);

    let isAllowedApiCall = allowedApiCall(payloadTemp);

    if (params.id) {
      if (isAllowedApiCall) {
        setLoading(true);
        payloadTemp.report_id = parseInt(params.id);
        payloadTemp.modified_by = userData.userID;
        delete payloadTemp.created_by;
        let res = await services.ServiceMethod(`/reports/edit`, "post", {
          payload: payloadTemp,
        });

        setLoading(false);
        if (res) {
          history.push({
            pathname: `/FaultReporter/admin/${params.type}`,
            state: { reportId: params.id, isArchive, res: res.body },
          });

          // history.push({
          //   pathname: `/FaultReporter/admin/${params.type}`,
          //   state: {  },
          // });
        }
      }
    } else {
      if (isAllowedApiCall) {
        setLoading(true);
        let newPayload = clearErrorkeyFromPayload(payload);
        let res = await services.ServiceMethod(`/reports/add`, "post", {
          payload: newPayload,
        });
        setLoading(false);
        if (res) {
          history.push({
            pathname: `/FaultReporter/admin/${params.type}`,
            state: { reportId: res.report_id, isArchive, res: res.body },
          });
        }
        // dispath(addReport(newPayload));
        // history.push(`/FaultReporter/admin/${params.type}`);
      }
    }
  };

  const clearErrorkeyFromPayload = (payloadTemp) => {
    let newPayload = cloneDeep(payloadTemp);
    newPayload.matchParentData.map((parent) => {
      if (parent.childMatch) {
        parent.matchChildData.map((child) => {
          delete child.errorMessage;
          delete child.errorMessage1;
        });
      } else {
        delete parent.errorMessage;
        delete parent.errorMessage1;
      }
    });
    return newPayload;
  };

  const allowedApiCall = (payloadTemp) => {
    let validationCheckTemp = cloneDeep(validationCheck);
    let isAllowedApiCall = true;

    if (!payloadTemp.report_name) {
      validationCheckTemp.report_name = true;
    } else {
      validationCheckTemp.report_name = false;
    }

    payloadTemp.matchParentData.map((parent) => {
      if (!parent.childMatch) {
        if (parent.errorMessage || parent.errorMessage1) {
          isAllowedApiCall = false;
          return;
        }
      } else {
        parent.matchChildData.map((child) => {
          if (child.errorMessage || child.errorMessage1) {
            isAllowedApiCall = false;
            return;
          }
        });
      }
    });

    setValidation(validationCheckTemp);
    return isAllowedApiCall && !validationCheckTemp.report_name ? true : false;
  };

  const deleteReportHandler = () => {
    setIsDeleteConfirmModalOpen(true);
  };

  const deleteReport = async () => {
    setLoading(true);
    let res = await services.ServiceMethod(
      `reports/delete?report_id=${params.id}`,
      "get"
    );
    setLoading(false);
    if (res) {
      history.push({
        pathname: `/FaultReporter/admin/${params.type}`,
        state: { res: res.body, isArchive },
      });
    }
    setIsDeleteConfirmModalOpen(false);
  };

  const onBackHandler = () => {
    history.push({
      pathname: `/FaultReporter/admin/${params.type}`,
      state: { reportId: params.id, isArchive },
    });
  };

  if (loading) {
    return <Loader />;
  }
  if (userData?.isAuthorized) {
    return (
      <>
        {optionData?.length > 0 ? (
          <div className="add-report-section">
            <div className="title-back">
              <span>{params.id ? "Edit Report" : "Add Report"}</span>
              <div className="back-save-btns">
                <button
                  type="button"
                  className="back-btn"
                  onClick={() => onBackHandler()}
                >
                  <span>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                  </span>
                  Back
                </button>
                {params.id && (
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#delete"
                    onClick={() => deleteReportHandler()}
                  >
                    Delete
                  </button>
                )}
                <button type="button" onClick={onSaveReport}>
                  Save
                </button>
              </div>
            </div>
            <div className="row report-name-section">
              <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12">
                <span>
                  {topSection.inputLabel} <span className="star-span">*</span>
                </span>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 not-error">
                <input
                  type="text"
                  name="reportName"
                  id="report_name"
                  value={[payload.report_name]}
                  placeholder={topSection.inputPlaceHolder}
                  onChange={onChangeHandler}
                />
                {validationCheck.report_name && (
                  <div className="msgError help-block">
                    <small className="error feedback-error">
                      {" "}
                      Please enter Report Name{" "}
                    </small>
                  </div>
                )}
              </div>
            </div>

            <div className="report-body">
              <div className="row top-row">
                <div className="col-lg-1 col-md-1 col-sm-2 col-xs-12">
                  <p>{filters.filterLabel}</p>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                  <select
                    id="match"
                    onChange={onChangeHandler}
                    value={payload.match}
                  >
                    {filters.filterOptions &&
                      filters.filterOptions.map((val, idx) => (
                        <option key={idx}>{val} </option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-2 col-md-2 col-sm-3 col-xs-12">
                  <p>Of the followings conditions:</p>
                </div>
              </div>
              {payload.matchParentData.map((grand, index) => (
                <>
                  {grand.childMatch ? (
                    <>
                      {index !== 0 && (
                        <span className="or-condition">
                          {payload.match == "ANY" ? "OR" : "AND"}
                        </span>
                      )}
                      <div className="report-body">
                        <div className="row">
                          <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                            <div className="row top-row">
                              <div className="col-lg-1 col-md-1 col-sm-2 col-xs-12">
                                <p>{filters.filterLabel}</p>
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <select
                                  id="childMatch"
                                  value={grand.childMatch}
                                  onChange={(e) =>
                                    onChangeChildrenHandler(e, index)
                                  }
                                >
                                  {filters.filterOptions &&
                                    filters.filterOptions.map((val, idx) => (
                                      <option key={idx} value={val}>
                                        {" "}
                                        {val}{" "}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                <p>Of the followings conditions:</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12 plus-btns">
                            <div className="row-add-btns">
                              <img
                                src={plusIcon}
                                alt="plus"
                                onClick={() => addRowHandler("add", index)}
                              />
                              {index !== 0 && (
                                <img
                                  src={deletedIcon}
                                  alt="deletedIcon"
                                  onClick={() =>
                                    deleteRowHandler("parent", index)
                                  }
                                />
                              )}
                              <img
                                src={nestedRowIcon}
                                alt="nestedRowIcon"
                                onClick={() => addRowHandler("nested", index)}
                              />
                            </div>
                          </div>

                          {grand.matchChildData.map((child, childIndex) => (
                            <React.Fragment key={childIndex}>
                             
                              <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                              {childIndex !== 0 && (
                                <span className="or-condition">
                                  {grand.childMatch == "ANY" ? "OR" : "AND"}
                                </span>
                              )}
                                <div className="row bottom-row-new">
                                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <select
                                      id="childrenLabel"
                                      value={child.col}
                                      onChange={(e) =>
                                        onChangeChildrenHandler(
                                          e,
                                          index,
                                          childIndex
                                        )
                                      }
                                    >
                                      {optionData.map((option, index) => (
                                        <option
                                          value={option.labelID}
                                          key={index}
                                        >
                                          {" "}
                                          {option.labelName}{" "}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <select
                                      id="childrenCondition"
                                      value={child.filter}
                                      onChange={(e) =>
                                        onChangeChildrenHandler(
                                          e,
                                          index,
                                          childIndex
                                        )
                                      }
                                    >
                                      {child.selectedChildrenCondition.condition.map(
                                        (option, index) => (
                                          <option
                                            value={option.conditionID}
                                            key={index}
                                          >
                                            {option.conditionName}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>
                                  {getInputBoxHandler(
                                    grand,
                                    index,
                                    childIndex,
                                    child
                                  )}
                                  <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <div className="row-add-btns">
                                      <img
                                        src={plusIcon}
                                        alt="plus"
                                        onClick={() =>
                                          addChildrenHandler(index)
                                        }
                                      />
                                      {childIndex !== 0 && (
                                        <img
                                          src={deletedIcon}
                                          alt="deletedIcon"
                                          onClick={() =>
                                            deleteRowHandler(
                                              "children",
                                              index,
                                              childIndex
                                            )
                                          }
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {/* {
                            childIndex !== 0 &&
                               <span className="or-condition child-or">
                                 {grand.childMatch == "ANY" ? "OR" : "AND"}</span> } */}
                              </div>
                              <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12"></div>
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {index !== 0 && (
                        <span className="or-condition">
                          {payload.match == "ANY" ? "OR" : "AND"}
                        </span>
                      )}
                      <div className="row bottom-row-new">
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                          <select
                            id="label"
                            value={grand.col}
                            onChange={(e) => onChangeHandler(e, index)}
                          >
                            {optionData.map((label, idx) => (
                              <option value={label.labelID} key={idx}>
                                {label.labelName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                          <select
                            id="condition"
                            value={grand.filter}
                            onChange={(e) => onChangeHandler(e, index)}
                            // value={grand["filter"]}
                          >
                            {grand.selectedCondition &&
                              grand.selectedCondition.condition.map(
                                (condition, id) => (
                                  <option
                                    value={condition.conditionID}
                                    key={id}
                                  >
                                    {condition.conditionName}
                                  </option>
                                )
                              )}
                          </select>
                        </div>
                        {getInputBoxHandler(grand, index, undefined, grand)}
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                          <div className="row-add-btns">
                            <img
                              src={plusIcon}
                              alt="plus"
                              onClick={() => addRowHandler("add", index)}
                            />
                            {index !== 0 && (
                              <img
                                src={deletedIcon}
                                alt="deletedIcon"
                                onClick={() =>
                                  deleteRowHandler("parent", index)
                                }
                              />
                            )}
                            <img
                              src={nestedRowIcon}
                              alt="nestedRowIcon"
                              onClick={() => addRowHandler("nested", index)}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ))}
            </div>
          </div>
        ) : (
          <Loader />
        )}
        {isDeleteConfirmModalOpen && (
          <div
            className="modal d-block modal-background"
            id="detailModal"
            tabIndex="-1"
            aria-labelledby="detailModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="detailModalLabel">
                    Delete Report
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setIsDeleteConfirmModalOpen(false)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body text-center p-b-30">
                  <p>Are you sure you want to delete the report?</p>
                  <div className="title-back">
                    <div className="back-save-btns">
                      <ButtonComponent
                        title="Cancel"
                        onClick={() => setIsDeleteConfirmModalOpen(false)}
                      />
                      <ButtonComponent
                        title="Delete"
                        onClick={() => deleteReport()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  return <div className="not-page">User Not Authorized</div>;
};
